<template>
  <div v-if="embedded" class="start-analysis-cta">
    <button type="button" class="start-analysis-cta__btn" @click="$emit('click')">
      开始分析
    </button>
    <!-- 预留 Tabbar + 安全区，避免长内容被遮挡 -->
    <div class="start-analysis-cta__spacer" />
  </div>
</template>

<script>
/**
 * 底部「开始分析」组件
 * - 仅在聚合页 Tab 内嵌场景展示（embedded=true）
 * - 非内嵌（单独打开页面）时隐藏
 */
export default {
  name: 'StartAnalysisCta',
  props: {
    /** 是否为 Tab 内嵌场景 */
    embedded: { type: Boolean, default: false }
  }
}
</script>

<style lang="less" scoped>
.start-analysis-cta {
  /* 吸底：在 Tab 的滚动容器内始终贴底显示 */
  position: sticky;
  bottom: 0;
  z-index: 2;
  padding: 28px 0 0;
  /* 底部渐变遮罩：保证按钮浮在内容之上但不突兀 */
  background: linear-gradient(
    180deg,
    rgba(247, 248, 250, 0) 0%,
    rgba(247, 248, 250, 0.92) 38%,
    rgba(247, 248, 250, 1) 100%
  );
}

.start-analysis-cta__btn {
  width: 100%;
  height: 46px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(90deg, #ffb84d 0%, #ff8a00 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 12px 22px rgba(255, 138, 0, 0.22);

  &:active {
    transform: scale(0.98);
    opacity: 0.92;
  }
}

.start-analysis-cta__spacer {
  height: calc(76px + env(safe-area-inset-bottom));
}
</style>




// WEBPACK FOOTER //
// src/components/StartAnalysisCta.vue